import type { IconSvgObject } from './types';

const HandPointingDown04Icon: IconSvgObject = [
  ["path", { d: "M14 11.6454V13.5C14 14.3284 13.3284 15 12.5 15H11M17 11V12.5C17 13.3284 16.3284 14 15.5 14H14.2328M11 15L11 12.5789M8 10L8 15V20C8 20.8284 8.67157 21.5 9.5 21.5C10.3284 21.5 11 20.8284 11 20V15M17.3237 13H18.5C19.3284 13 20 12.3284 20 11.5V5.5C20 3.84314 18.6569 2.5 17 2.5L9.60555 2.5C8.60249 2.5 7.6658 3.0013 7.1094 3.8359L4.50385 7.74423C4.17531 8.23703 4 8.81605 4 9.40833L4 9.75736C4 10.553 4.31607 11.3161 4.87868 11.8787L8 15", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default HandPointingDown04Icon;
